import { render, staticRenderFns } from "./TimeAgoFilter.vue?vue&type=template&id=585456ce&"
import script from "./TimeAgoFilter.vue?vue&type=script&lang=js&"
export * from "./TimeAgoFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports